import callApi from '@niarab2c/frontend-commons/src/util/callApi';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type { AddonsRule, AntifraudRule, BuyerPaymentRule, CheckoutFlowRule, CheckoutFormRule as TCheckoutFormRule, HotelPostSearchRule, LedgerConfiguration, PrivacyRule, LoyaltyProgram } from 'niara-spear-crudmodel';
import { CompleteRootState } from '../base';
type LedgerConfig = LedgerConfiguration & {
  credentialId: string;
};
type CheckoutFormRule = TCheckoutFormRule & {
  loyaltyProgram?: LoyaltyProgram;
};
type Rules = {
  checkoutFormRule: CheckoutFormRule | null;
  buyerPaymentRule: BuyerPaymentRule | null;
  loyaltyConfiguration: LedgerConfiguration | null;
  tierLoyaltyConfiguration: LedgerConfig | null;
  checkoutFlowRule: CheckoutFlowRule | null;
  addonsRule: AddonsRule | null;
  hotelPostSearchRule: HotelPostSearchRule | null;
  privacyRule: PrivacyRule | null;
  antifraudRule: Partial<AntifraudRule> | null;
};
type RulesContext = {
  clientId: string;
  isLoyaltyOptIn: boolean;
  isForGroups: boolean;
  landingPageId?: string;
  propertyId?: string;
  //   tenantId: string
};
export type RulesState = {
  currentRules?: Rules;
  rulesContext?: RulesContext;
};

/**
 *
 */
export const loadRules = createAsyncThunk<{
  rules: Rules;
  rulesContext: RulesContext;
}, void | Partial<RulesContext>, {
  state: CompleteRootState;
}>('rules/loadRules', async function (options, {
  getState
}) {
  if (!options) {
    // só para ajudar no typing
    options = {};
  }
  // Agora com a unificação pego o clientId do hotelSeach ou do core
  const clientId = getState().core?.clientId ?? getState().quotation?.quotation?.clientId ?? getState().shoppingCart?.clientId ?? getState().authentication?.user?.clientId ?? options?.clientId;

  //   const tenantId = getState().core?.tenantId
  const shoppingCart = getState().shoppingCart;
  const isLoyaltyOptIn = options?.isLoyaltyOptIn ?? (shoppingCart?.items?.some(item => item?.loyaltyOptInRoomRateId) && shoppingCart?.isLoyaltyOptIn && true || undefined);
  const propertyId = options ? options?.propertyId : undefined;
  const isForGroups = options?.isForGroups ?? getState()?.hotel?.isForGroups;
  const landingPageId = getState().storefrontConfig?.storefront?.landingPageId ?? options?.landingPageId;
  const rulesContext: RulesContext = {
    clientId,
    landingPageId,
    isForGroups,
    isLoyaltyOptIn,
    propertyId
  }; // TODO complementar o contexto com mais dados (hotel, data, etc)
  // TODO não recarregar se não mudou o rulesContext
  const result: Rules = await callApi('niara-spear-commons', `/genericRuleResolver/details`, 'get', {
    params: rulesContext
  });
  return {
    rules: result,
    rulesContext
  };
});
const rulesSlice = createSlice({
  initialState: {} as RulesState,
  name: 'rules',
  reducers: {},
  extraReducers: function (builder) {
    builder.addCase(loadRules.fulfilled, (state, action) => {
      if (action.payload.rules) {
        state.currentRules = action.payload.rules;
        state.rulesContext = action.payload.rulesContext;
      }
    });
  }
});
export default rulesSlice.reducer;